export const BASE = '/notification-management';
export const menus = [
  ['events', 'Sự kiện & quy tắc'], ['campaigns', 'Chiến dịch'],
  ['templates', 'Mẫu thông báo'], ['history', 'Lịch sử khách'], ['tests', 'Gửi thử'],
];
export const eventGroups = { order: 'Đơn hàng & vé', wallet: 'Ví & thanh toán', reward: 'Thưởng & kết quả', account: 'Tài khoản', engagement: 'Tương tác', service: 'Dịch vụ' };
export const sources = { source_verified: 'Đã xác minh nguồn', needs_proof: 'Cần bằng chứng', needs_journal: 'Cần nhật ký nguồn', new_notification_feature: 'Nguồn thông báo mới', future: 'Chưa có nguồn' };
export const locks = { ADAPTER_NOT_INSTALLED: 'Chưa nối nguồn sự kiện', CAMPAIGNS_DISABLED: 'Backend chưa bật chiến dịch', PUSH_NOT_IMPLEMENTED: 'Push Firebase chưa tích hợp' };
export const states = { draft: 'Nháp', scheduled: 'Đã hẹn giờ', queued: 'Trong hàng đợi', running: 'Đang xử lý', paused: 'Tạm dừng', completed: 'Hoàn tất', completed_with_errors: 'Hoàn tất có lỗi', cancelled: 'Đã hủy', failed: 'Thất bại', succeeded: 'Hoàn tất' };
export const outcomes = { materialized: 'Đã tạo hộp tin', skipped_optout: 'Không đồng ý nhận', skipped_account: 'Tài khoản không phù hợp', skipped_expired: 'Hết hiệu lực', skipped_ref: 'Ref không còn hợp lệ', skipped_rule: 'Quy tắc đã tắt', skipped_budget: 'Giới hạn tần suất / khoảng nghỉ', error: 'Lỗi' };
export const outcomeReason = code => ({ INBOX_MARKETING_COOLDOWN: 'Đang nghỉ sau thông báo giao dịch',
  INBOX_MARKETING_BUDGET: 'Đã đạt giới hạn tin marketing' }[code] || code);
export const manualEvents = ['campaign.published', 'service.announcement', 'service.maintenance_notice', 'service.app_update_notice', 'engagement.onboarding_tip'];
export const manualLabels = ['Chiến dịch', 'Thông tin dịch vụ', 'Thông báo bảo trì', 'Cập nhật ứng dụng', 'Hướng dẫn khách mới'];
export function campaignActions(status, expiresAt, now = Date.now()) {
  const actions = ['clone', 'report'];
  if (status === 'draft') actions.unshift('edit');
  if (['scheduled', 'queued', 'running'].includes(status)) actions.unshift('pause');
  if (status === 'paused' && Date.parse(expiresAt) > now) actions.unshift('resume');
  if (['draft', 'scheduled', 'queued', 'running', 'paused'].includes(status)) actions.push('cancel');
  return actions;
}
export function stamp(value) {
  return value ? new Intl.DateTimeFormat('vi-VN', { timeZone: 'Asia/Ho_Chi_Minh', dateStyle: 'short', timeStyle: 'short' }).format(new Date(value)) : '—';
}
export function localVN(iso) {
  return iso ? new Date(Date.parse(iso) + 7 * 3600000).toISOString().slice(0, 16) : '';
}
export function isoVN(local) {
  if (!local) throw new Error('Vui lòng nhập ngày giờ (giờ Việt Nam).');
  const date = new Date(`${local}:00+07:00`);
  if (Number.isNaN(date.getTime())) throw new Error('Ngày giờ chưa hợp lệ.');
  return date.toISOString();
}
export function parseIds(text, max = 1000) {
  const ids = [...new Set(text.split(/[\s,;]+/).filter(Boolean))];
  if (!ids.length || ids.length > max || ids.some(id => id.length > 128)) throw new Error(`Nhập từ 1 đến ${max} ID khách hợp lệ.`);
  return ids;
}
export function canonical(value) {
  return Array.isArray(value) ? `[${value.map(canonical).join(',')}]` : value && typeof value === 'object'
    ? `{${Object.keys(value).sort().map(key => JSON.stringify(key) + ':' + canonical(value[key])).join(',')}}` : JSON.stringify(value);
}
export function newKey() {
  if (!window.crypto?.getRandomValues) throw new Error('Trình duyệt chưa hỗ trợ tạo khóa an toàn. Vui lòng dùng trình duyệt mới.');
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
/** Retry keys stay in memory within the module; no token/content is persisted to browser storage. */
export function mutationRunner(api, makeKey = newKey) {
  const keys = new Map();
  return async (method, path, options = {}) => {
    if (!options.idempotent) return api(method, path, options);
    const identity = canonical({ method, path, body: options.body, version: options.version ?? null });
    if (!keys.has(identity)) keys.set(identity, makeKey());
    return api(method, path, { ...options, key: keys.get(identity) });
  };
}
export function safeImage(url) {
  try { const parsed = new URL(url); return parsed.protocol === 'https:' && !parsed.username && !parsed.password ? url : null; }
  catch { return null; }
}
export function emptyCampaign() {
  return { name: '', eventType: 'campaign.published', category: 'news', content: { title: '', body: '', imageAssetId: null,
    action: { kind: 'none' }, refs: [], campaignRef: null }, audience: { kind: '' },
    channels: { inbox: true, push: false }, expiresAt: new Date(Date.now() + 86400000).toISOString() };
}
export function validateCampaign(input) {
  if (!input.name.trim() || !input.content.title.trim() || !input.content.body.trim()) throw new Error('Nhập tên chiến dịch, tiêu đề và nội dung.');
  if (!['all_eligible', 'user_ids', 'game_followers'].includes(input.audience.kind)) throw new Error('Chọn nhóm đối tượng nhận chiến dịch.');
  if (!input.eventType.startsWith('service.') && input.category !== 'news') throw new Error('Tin tương tác/chiến dịch dùng nhóm Ưu đãi.');
  if (/\{\{|\}\}/.test(input.content.title + input.content.body)) throw new Error('Chiến dịch chưa hỗ trợ placeholder.');
  if (input.content.campaignRef && !/^[A-Za-z0-9._-]{1,64}$/.test(input.content.campaignRef)) throw new Error('Mã chiến dịch chỉ dùng chữ, số, dấu chấm, gạch dưới hoặc gạch ngang.');
  const end = Date.parse(input.expiresAt);
  if (!(end > Date.now() && end <= Date.now() + 90 * 86400000)) throw new Error('Hạn nội dung phải nằm trong 90 ngày tới.');
  if (input.audience.kind === 'game_followers' && !input.audience.gameId?.trim()) throw new Error('Nhập ID game cho nhóm theo dõi.');
  if (input.content.action.kind === 'external_url') {
    if (!safeImage(input.content.action.url)) throw new Error('Link cần dùng HTTPS. Domain được backend kiểm tra.');
  }
  if (input.content.action.kind !== 'none' && !input.content.action.label?.trim()) throw new Error('Nhập nhãn nút liên kết.');
  if (input.content.action.kind === 'game' && !input.content.action.gameId?.trim()) throw new Error('Nhập ID game cho liên kết.');
  if (input.content.action.kind === 'entity' && !input.content.action.ref) throw new Error('Chọn và xác minh Ref cho nút liên kết.');
}
